var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsGrDelivery = function SvgNnIconFlagsGrDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-GR-delivery_svg__Lager_40",
    "data-name": "Lager 40",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-GR-delivery_svg__cls-3{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.13.13h50.22v33.56H.13z",
    style: {
      fill: "#0095ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 11.44h7.45v-3.7h-7.45V.25H7.79v7.49H.25v3.7h7.54v7.4H.25v3.7h49.97v-3.7h-38.7z",
    className: "nn-icon-flags-GR-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.97 4.03h31.24v3.7H18.97zM18.97 11.44h31.24v3.7H18.97zM.25 26.24h49.97v3.7H.25z",
    className: "nn-icon-flags-GR-delivery_svg__cls-3"
  })));
};
export default SvgNnIconFlagsGrDelivery;